export default __webpack_public_path__ + "img/icon-facebook.png?9d3a";